import React from 'react';
import Image, { getVariantUrls } from '@fenderdigital/react-ui-kit/image';
import { defineMessages, FormattedMessage } from 'react-intl';
import Link from '../Link';

const messages = defineMessages({
  label: {
    id: 'tunerHeadstock.label',
    defaultMessage: '{label}',
  },
});

interface TunerHeadStockItem {
  label: string;
  url: string;
  'image-url': string;
}

interface TunerHeadStockProps {
  list?: TunerHeadStockItem[];
}

const TunerHeadstock: React.FC<TunerHeadStockProps> = ({ list }) => (
  <div className="tuner-headstock" data-id="tuner-headstock">
    <ul className="list pl0 ma0 mb3 mb4-ns mw5 center mh0-ns mw7-ns flex flex-wrap">
      {list?.map(
        (listItem): JSX.Element => (
          <li className="w-50 w-25-ns tc mb4 ph2 ph0-ns" key={`tuner-headstock-${listItem.label}`}>
            <Link className="dib blue w-100" target="_blank" to={listItem.url}>
              <div className="mb2">
                <Image images={getVariantUrls(listItem['image-url'], null)} ratio={1} />
              </div>
              <span className="futura-heavy ttc">
                <FormattedMessage {...messages.label} values={{ label: listItem.label }} />
              </span>
            </Link>
          </li>
        ),
      )}
    </ul>
  </div>
);

export default TunerHeadstock;
